import { AppConfig } from 'AppConfig'
import { getAuthHeaderConfig } from 'utils/authUtils'
import { CREATE_TOKEN_URL } from 'api/doccheckApi/paths'
import { getUrlCountryPath, getLocationOrigin, getLanguageCode } from 'utils/urlUtils'
import { authGetQuery } from '../AxiosQueries'

const {
  audience,
  loginId,
} = AppConfig.authApi.docCheck


const getValidatedDocCheckUrl = (loginId) => {
   const redirectUri = `${getLocationOrigin()}/${getUrlCountryPath()}/`
   const targetUrl =   `https://auth.doccheck.com/de/authorize?grant_type=authorization_code&response_type=code&client_id=${loginId}&redirect_uri=${redirectUri}&scope=unique_id%20email%20profession%20occupation_detail%20country%20name%20email%20address%20occupation_detail`


  try {
    const parsed = new URL(targetUrl);
    // Ensure we are only redirecting to the trusted DocCheck domain
    if (parsed.hostname === "auth.doccheck.com" && parsed.protocol === "https:") {
      return targetUrl;
    }
  } catch (e) {
    console.error("Invalid Redirect URL");
  }

  return getLocationOrigin(); // Safe fallback to home page
};

const docCheckAuth = {
  docCheckRegisterRedirect: () => {

    const url = 'https://www.doccheck.com/register'

    window.open(url, '_blank')

  },
  docCheckLoginRedirect: () => {
    const safeUrl = getValidatedDocCheckUrl(loginId);    
    window.location.href = safeUrl;

  },
  createUserToken: ({ authCode, doccheckuserconsent, taxonomyRegistration, useNewDoccheckApi = false }) => {
    doccheckuserconsent = doccheckuserconsent ? `&doccheckuserconsent=${doccheckuserconsent}` : '';
    const additionalInfo = JSON.stringify(taxonomyRegistration).replaceAll('&', '%26');
    let url = `${CREATE_TOKEN_URL}?code=${authCode}${doccheckuserconsent}&additionalInfo=${additionalInfo}`;
    const returnURI = `${getLocationOrigin()}/${getUrlCountryPath()}/`
    if (useNewDoccheckApi) {
      url = `${url}&isNew=true&langCode=${getLanguageCode()}-${getLanguageCode()}&returnURI=${returnURI}`;
    }

    return authGetQuery({ url, config: getAuthHeaderConfig({ audienceUrl: audience }) }).then((response) => response);
  },
}

export { docCheckAuth }
